import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { money } from "@/lib/format";

export default function PaymentSuccess({ state, receipt, plan, onClose }) {
  const navigate = useNavigate();
  const subscribed = state === "subscribed";

  const goToThankYou = () => {
    try {
      sessionStorage.setItem("bc_last_receipt", JSON.stringify({
        amount: receipt.amount,
        label: receipt.label,
        cycles: receipt.cycles || plan?.cycles || null,
        type: subscribed ? "subscribed" : "paid",
      }));
    } catch {
      // storage unavailable — page falls back to generic thank-you
    }
    onClose();
    navigate("/thank-you");
  };

  return (
    <div className="text-center" data-testid="paypal-success">
      <CheckCircle2 size={40} className="mx-auto mb-6 text-forest" />
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">
        {subscribed ? "Payment plan active" : "Payment complete"}
      </p>
      <h3 className="mb-4 font-serif text-3xl font-medium text-pine">Thank you.</h3>
      <p className="mb-2 font-serif text-2xl font-semibold text-forest">
        {money(receipt.amount)}
        {subscribed && <span className="text-base font-normal"> / month × {receipt.cycles}</span>}
      </p>
      <p className="mb-8 text-sm leading-relaxed text-pine/60">
        {subscribed
          ? `${receipt.label}. PayPal will charge each monthly instalment automatically — a confirmation is on its way to your inbox.`
          : plan
          ? `${receipt.label}. Your receipt and next-instalment details are on their way to your inbox.`
          : `${receipt.label}. A receipt is on its way to your inbox, and Zecharias will follow up with next steps.`}
      </p>
      <button
        onClick={goToThankYou}
        data-testid="paypal-success-done"
        className="w-full border border-forest bg-forest px-6 py-3.5 font-mono text-xs uppercase tracking-[0.25em] text-bone transition-colors duration-300 hover:bg-transparent hover:text-forest"
      >
        See what happens next
      </button>
    </div>
  );
}
